import { Box, Chip, Typography } from '@mui/material'
import CheckCircleIcon from '@mui/icons-material/CheckCircle'
import CancelIcon from '@mui/icons-material/Cancel'
import InfoIcon from '@mui/icons-material/Info'
import { useTranslation } from 'react-i18next'
import { CollapsibleSection } from '../CollapsibleSection'
import styles from './styles.module.scss'

export const RenaperValidation = ({ metadata }) => {
  const { t } = useTranslation(['common'])

  const renaperValidation = metadata?.renaperValidation

  if (!renaperValidation) {
    return null
  }

  const getStatusColor = (status) => {
    switch (status) {
      case 'APPROVED':
        return '#00B85F'
      case 'REJECTED':
        return '#dc3545'
      default:
        return '#ffc107'
    }
  }

  const getStatusIcon = (status) => {
    switch (status) {
      case 'APPROVED':
        return <CheckCircleIcon />
      case 'REJECTED':
        return <CancelIcon />
      default:
        return <InfoIcon />
    }
  }

  const statusLabel = renaperValidation.status === 'APPROVED' ? t('common:approved') : renaperValidation.status === 'REJECTED' ? t('common:declined') : renaperValidation.status
  const summary = `${t('common:status')}: ${statusLabel}`

  return (
    <CollapsibleSection title={t('common:renaperValidation')} summary={summary}>
      <Box className={styles.gridItems}>
        <Box className={styles.gridItem}>
          <Typography variant="subtitle2" color="textSecondary">
            {t('common:status')}
          </Typography>
          <Chip
            icon={getStatusIcon(renaperValidation.status)}
            label={
              renaperValidation.status === 'APPROVED'
                ? t('common:approved')
                : renaperValidation.status === 'REJECTED'
                ? t('common:declined')
                : renaperValidation.status
            }
            sx={{
              backgroundColor: getStatusColor(renaperValidation.status),
              color: '#FFFFFF',
              fontWeight: 500,
              '& .MuiChip-icon': {
                color: '#FFFFFF',
              },
            }}
          />
        </Box>

        <Box className={styles.gridItem}>
          <Typography variant="subtitle2" color="textSecondary">
            {t('common:enabled')}
          </Typography>
          <Typography variant="body1" fontWeight={500}>
            {renaperValidation.enabled ? t('common:yes') : t('common:no')}
          </Typography>
        </Box>

        {renaperValidation.reason && (
          <Box className={styles.gridItem}>
            <Typography variant="subtitle2" color="textSecondary">
              {t('common:reason')}
            </Typography>
            <Typography variant="body1" fontWeight={500}>
              {renaperValidation.reason}
            </Typography>
          </Box>
        )}

        {renaperValidation.mismatch !== undefined && (
          <Box className={styles.gridItem}>
            <Typography variant="subtitle2" color="textSecondary">
              {t('common:mismatch')}
            </Typography>
            <Typography variant="body1" fontWeight={500}>
              {renaperValidation.mismatch ? t('common:yes') : t('common:no')}
            </Typography>
          </Box>
        )}

        {renaperValidation.errorMessage && (
          <Box className={styles.gridItem}>
            <Typography variant="subtitle2" color="textSecondary">
              {t('common:errorMessage')}
            </Typography>
            <Typography variant="body1" fontWeight={500} color="error">
              {renaperValidation.errorMessage}
            </Typography>
          </Box>
        )}
      </Box>
    </CollapsibleSection>
  )
}
